import * as React from "react"

function SvgChevronUp(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 10"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.042}
        d="M15.516 9.153L8.28.976a.325.325 0 00-.487 0L.557 9.153"
      />
    </svg>
  )
}

export default SvgChevronUp
